module.exports = __webpack_public_path__ + "img/dimsum-2.60776a49.jpg";